/* eslint-disable no-console */
import {
  tweenTicketToGround,
  tweenTicketToScreen,
  tweenTicketToStar, tweenTicketToTrashCan
} from 'rf-ui/GameRenderer/wheelAnimatior';
import type WheelOfFortuneRenderer from 'rf-ui/GameRenderer/WheelOfFortuneRenderer';
import { Group } from 'two.js/src/group';
import Ticket from 'rf-ui/GameRenderer/entities/ticket';

type TicketAnimationParameters = {
  wheelRadius: number;
  textPos: number;
};

export type AnimationName = 'screen' | 'stars' | 'ground' | 'trash';

type RandomAnimation = {
  animationName: AnimationName;
  animationTime: number;
};

export default class TicketAnimator {
  private readonly chances = {
    ticketOnScreen: 10,
    ticketToStars: 10,
    ticketOnGround: 10,
    ticketsToTrash: 10
  };

  private readonly renderer: WheelOfFortuneRenderer;

  private readonly parameters: TicketAnimationParameters;

  constructor(renderer: WheelOfFortuneRenderer, parameters: TicketAnimationParameters) {
    this.renderer = renderer;
    this.parameters = parameters;
  }

  getRandomAnimation(size: number): RandomAnimation {
    const animations: AnimationName[] = [];
    Array.from(Array(this.chances.ticketOnScreen))
      .forEach(() => {
        animations.push('screen');
      });
    Array.from(Array(this.chances.ticketToStars))
      .forEach(() => {
        animations.push('stars');
      });
    if (size < Math.PI * 0.2) {
      Array.from(Array(this.chances.ticketOnGround))
        .forEach(() => {
          animations.push('ground');
        });
    }
    if (size < Math.PI * 0.2) {
      Array.from(Array(this.chances.ticketsToTrash))
        .forEach(() => {
          animations.push('trash');
        });
    }

    const animationName = animations[Math.floor(Math.random() * animations.length)] || 'stars';

    switch (animationName) {
      case 'screen':
        return { animationName, animationTime: 2200 };
      case 'stars':
        return { animationName, animationTime: 1000 };
      case 'ground':
        return { animationName, animationTime: 1000 };
      case 'trash':
        return { animationName, animationTime: 1000 };
      default:
        return { animationName: 'stars', animationTime: 1000 };
    }
  }

  performAnimation(animationName: AnimationName, size: number, wedgeGroup: Ticket): void {
    switch (animationName) {
      case 'screen':
        tweenTicketToScreen.call(this.renderer, wedgeGroup, size);
        break;
      case 'stars':
        tweenTicketToStar.call(this.renderer, wedgeGroup, size);
        break;
      case 'ground':
        tweenTicketToGround.call(this.renderer, wedgeGroup, size, this.parameters);
        break;
      case 'trash':
        tweenTicketToTrashCan.call(this.renderer, wedgeGroup, size, this.parameters);
        break;
      default:
        console.error(`Unknown animation type '${animationName}'`);
        wedgeGroup.remove();
        break;
    }
  }
}
